import {Button, Tooltip,} from '@mui/material';
import React, {useContext} from 'react';
import {OpenAPI} from '../../../../../services/openapi';
import dayjs from 'dayjs';
import ZeiterfassungDashboardContext from '../../../../../Contexts/ZeiterfassungDashboardContext/ZeiterfassungDashboardContext';
import TableViewIcon from '@mui/icons-material/TableView';
import {useTranslation} from 'react-i18next';
import DownloadIcon from "@mui/icons-material/Download";

export default function ExportWorkingDataExcel() {
    const {selectedDateStart, selectedDateEnde, filter} =
        useContext(ZeiterfassungDashboardContext);
    const {t} = useTranslation();

    const formatDateForUrl = (date: Date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const buildQueryParams = () => {
        const params = new URLSearchParams();
        params.append('timeInterval_start', formatDateForUrl(selectedDateStart));
        params.append('timeInterval_end', formatDateForUrl(selectedDateEnde));
        params.append('filter_department', filter.department || '');
        params.append('filter_user', filter.user || '');
        if (filter.bauvorhaben) {
            params.append('filter_bauvorhaben', filter.bauvorhaben);
        }
        return params.toString();
    };

    const generateFilename = () => {
        const startDateFormatted = dayjs(selectedDateStart).format('YYYY-MM-DD');
        const endDateFormatted = dayjs(selectedDateEnde).format('YYYY-MM-DD');
        let filename = `arbeitszeit_export_${startDateFormatted}-${endDateFormatted}`;

        if (filter.department) {
            filename += `_${filter.department}`;
        }

        if (filter.user) {
            filename += `_${filter.user}`;
        }

        if (filter.bauvorhaben) {
            filename += `_BVH-${filter.bauvorhaben}`;
        }

        return `${filename}.xlsx`;
    };

    const handleExcelExport = async () => {
        try {
            const url = `${OpenAPI.BASE}/arbeitzeit/dashboard/export/worktimes?${buildQueryParams()}`;

            const response = await fetch(url, {
                method: 'POST',
            });

            if (!response.ok) {
                throw new Error(`Export failed: ${response.status} ${response.statusText}`);
            }

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');

            downloadLink.style.display = 'none';
            downloadLink.href = downloadUrl;
            downloadLink.download = generateFilename();

            document.body.appendChild(downloadLink);
            downloadLink.click();

            window.URL.revokeObjectURL(downloadUrl);
            document.body.removeChild(downloadLink);
        } catch (error) {
            console.error('Excel export failed:', error);
        }
    };

    return (
        <Tooltip title="Excel Export - Arbeitszeiten als XLSX herunterladen">
            <Button
                variant="contained"
                onClick={handleExcelExport}
                startIcon={<DownloadIcon />}
                sx={{
                    backgroundColor: '#2e7d32',
                    color: 'white',
                    fontWeight: 'bold',
                    textTransform: 'none',
                    minWidth: '120px',
                    '&:hover': {
                        backgroundColor: '#1b5e20',
                        boxShadow: '0 4px 12px rgba(46, 125, 50, 0.4)',
                    },
                    '&:active': {
                        backgroundColor: '#1b5e20',
                    },
                    boxShadow: '0 2px 8px rgba(46, 125, 50, 0.3)',
                }}
            >
                Export
            </Button>
        </Tooltip>
    );
}
